(function() {
  if (window.__cpgAtcInit) return;
  window.__cpgAtcInit = true;

  function openCartDrawer() {
    // UpCart APIs
    var apis = [
      function() { return window.uCart && window.uCart.show && window.uCart.show(); },
      function() { return window.uCart && window.uCart.open && window.uCart.open(); },
      function() { return window.upcart && window.upcart.show && window.upcart.show(); },
      function() { return window.upcart && window.upcart.open && window.upcart.open(); },
      function() { return window.Upcart && window.Upcart.show && window.Upcart.show(); },
      function() { return window.UpCart && window.UpCart.open && window.UpCart.open(); }
    ];

    for (var i = 0; i < apis.length; i++) {
      try { if (apis[i]() !== undefined) return; } catch(e) {}
    }

    // Dispatch upcart events
    ['upcart:open', 'upcart:refresh', 'upcart:cart-updated'].forEach(function(evt) {
      document.dispatchEvent(new CustomEvent(evt, { bubbles: true }));
    });

    // Try finding upcart element
    var el = document.querySelector('upcart-app, #upcart, [id*="upcart"]');
    if (el) el.dispatchEvent(new CustomEvent('open', { bubbles: true }));
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cpg-card__atc-btn');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status) {
        btn.textContent = 'Error';
      } else {
        btn.textContent = 'Added!';
        openCartDrawer();
      }
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
  });
})();
